import React, { useState } from 'react';
import { motion } from 'framer-motion';
import i18n from './i18n';  // Import the i18n instance
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App: React.FC = () => {
  const [language, setLanguage] = useState('it');

  const changeLanguage = (lng: string) => {
    setLanguage(lng);
    i18n.changeLanguage(lng);  // Use the imported i18n instance
  };

  return (
    <div className="bg-gradient-to-br from-blue-100 to-purple-100 min-h-screen">
      <Header language={language} changeLanguage={changeLanguage} />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Hero />
        <About />
        <Services />
        <Projects />
        <Contact />
      </motion.div>
      <Footer />
    </div>
  );
}

export default App;